<template lang="pug" src='./custom-why-before.pug'></template>

<script>
import Icon from 'components/icon/icon'

export default {
  data () {
    return {
      swiperOption: {
        speed: 750,
        slidesPerView: 2,
        spaceBetween: 32,
        autoplay: {
          delay: 5000
        },
        pagination: {
          el: '.custom-why-before__pagination',
          clickable: true
          // dynamicBullets: true,
          // dynamicMainBullets: 6
        },
        breakpoints: {
          990: {
            slidesPerView: 1
          }
        }
      }
    }
  },
  computed: {
    swiper () {
      return this.$refs.mySwiper.swiper
    }
  },
  props: ['props'],
  components: {
    Icon
  },
  methods: {
    slidePrev () {
      this.swiper.slidePrev()
    },
    slideNext () {
      this.swiper.slideNext()
    }
  }
}
</script>



// WEBPACK FOOTER //
// custom-why-before.vue?480f3edb